<!--腾讯地图 -->
<!--
  使用方式：  change回调方法  lat lng address 回显参数
  <tx-map @change="changeAddress" :lat="" :lng="" :address-text=""></tx-map>
-->
<template>
  <div class="ib">
    <div>
      <el-input  :disabled="true" class="w600"  v-model="address.address">
        <template #append>
          <i @click="open()" style="font-size: 18px" class="el-icon-location"></i>
        </template>
      </el-input>
    </div>
    <el-dialog v-model="visible" width="80%">
      <div class="address-search-box">
        <div class="address-label">地址：</div>
        <div class="input-box">
          <el-input class="w500" placeholder="请输入搜索地址" v-model="keywords" @keyup.enter.native="searchAddress()"></el-input>
          <div class="input-auto" v-show="showAuto">
            <div class="auto-item" @click="selectItem(item)" v-for="item in queryResult">
              {{item.title}}
            </div>
          </div>
        </div>
      </div>
      <div id="container" style="width:100%;height:600px;margin-top: 20px"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props:['lat','lng','addressText'],
    name: "tx-map",
    data() {
      return {
        address:{address:"",lat:0,lng:0},
        visible:false,
        map:null,
        markersArray:[],
        searchService:null,
        suggest:null,
        keywords:"",
        queryResult:null,
        showAuto:false,
        selectItemObj:null,
        geocoder:null,
        marker:null,
        initMarker:null,
        markerClick:false,
      }
    },
    mixins: [tableBase],
    watch:{
      keywords(n){
        this.keywords = n;
        if(!(this.selectItemObj&&this.selectItemObj.name===n)){
          this.searchAddress();
        }
      },
      lat:function(n){
        if(n){
          this.address.lat = n;
        }else{
          this.address.lat = 23.0632;
        }
      },
      lng:function(n){
        if(n){
          this.address.lng = n;
        }else{
          this.address.lng =113.1553;
        }

      },
      addressText:function(n){
        this.address.address = n;
      }
    },
    methods: {
      open(){
        this.visible = true;
        this.keywords = "";
        this.selectItemObj = null;
        this.showAuto = false;
        this.$nextTick(()=>{
          if(!this.map){
            this.initMap();
          }
          this.renderMarker();
        })
      },
      renderMarker(){
        if(this.initMarker){
          this.initMarker.setMap(null);
          this.initMarker = null;
        }
        //初始化有地址 默认给加上标注
        //console.log(this.lat , this.lng);
        if(this.lat&&this.lng){
          let pos = new TMap.LatLng(this.lat,this.lng);
          this.initMarker = new TMap.MultiMarker({
            id: 'marker-center',
            map: this.map,
            styles: {
              marker: new TMap.MarkerStyle({
                width: 20, // 样式宽
                height: 30, // 样式高
                anchor: { x: 10, y: 30 }, // 描点位置
              })
            },
            geometries: [{
              // 标记位置(纬度，经度，高度)
              position: pos,
              id: 'marker',
            }]
          });
        }
      },
      initMap() {
        var myLatlng = new TMap.LatLng(this.address.lat,this.address.lng);
        var myOptions = {
          zoom: 16,
          center: myLatlng,
        };
        this.map = new TMap.Map(document.getElementById("container"), myOptions);
        this.map.on("click",async (e)=>{
          //console.log(e,"map-click");
          if(this.markerClick){
            this.markerClick = false;
            return;
          }
          this.markerClick = false;
          // 获取点击后的地图坐标
          let poi = new TMap.LatLng(e.latLng.lat,e.latLng.lng);
          const results = await this.geocoder.getAddress({location: poi})
          const address = results.result.address_component;
          let m = {
            location:{lat:e.latLng.lat,lng:e.latLng.lng},
            address:results.result.address,
            province:address.province,
            city:address.city,
            district:address.district,
          }
          this.setAddress(m);
        });
        //调用Poi检索类。用于进行本地检索、周边检索等服务。
        //this.searchService = new TMap.service.Search({ pageSize: 10 });
        this.suggest = new TMap.service.Suggestion({pageSize: 10});
        this.geocoder = new TMap.service.Geocoder();
      },
      setAddress(m){
        this.showConfirm("是否选择此位置?",()=>{
          this.address = {address:m.address,province:m.province,city:m.city,region:m.district,lat:m.location.lat,lng:m.location.lng};
          this.$emit('change',this.address );
          this.visible = false;
        })
      },
      async searchAddress(){
        if(!this.keywords)return;
        this.showAuto=  true;
        const results = await this.suggest.getSuggestions({keyword:this.keywords,location: this.map.getCenter()});
        this.queryResult = results.data;
      },
      selectItem(item){
        if(this.marker){
          this.marker.setMap(null);
          this.marker = null;
        }
        let pos = new TMap.LatLng(item.location.lat,item.location.lng);
        this.map.setCenter(pos);
        //this.map.zoomBy(13);
        this.selectItemObj = item;
        this.keywords = item.title;
        this.marker = new TMap.MultiMarker({
          id: 'marker-layer',
          map: this.map,
          styles: {
            marker: new TMap.MarkerStyle({
              width: 20, // 样式宽
              height: 30, // 样式高
              anchor: { x: 10, y: 30 }, // 描点位置
            })
          },
          geometries: [{
            // 标记位置(纬度，经度，高度)
            position: pos,
            id: 'marker',
          }]
        });
        this.marker.on("click", (event)=>{
          this.markerClick = true;
          this.setAddress(item);
          return true;
        })
        this.$nextTick(()=>{
          this.showAuto = false;
        })
      }
    },
    mounted() {
      this.address = {address:this.addressText,lat:this.lat?this.lat:23.0632,lng:this.lng?this.lng:113.1553};
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .el-input__inner{
    background: var(--el-input-background-color) !important;
  }
  /deep/ .el-input-group__append{
    border: none;
    background: var(--el-input-background-color) !important;
  }
  .address-search-box{
  display: flex;
  align-items: center;
  .address-label{
    font-weight: bold;
    font-size: 16px;
  }
  .input-box{
    position: relative;
    .input-auto{
      position: absolute;
      display: flex;
      flex-direction: column;
      z-index: 999999;
      background: #fff;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      width: 100%;
      .auto-item{
        line-height: 30px;
        margin: 0 16px;
        &:hover{
          color: #F88000;
          cursor: pointer;
        }
      }
      .auto-item+.auto-item{
        border-top: 1px solid #e6e6e6;
      }
    }

  }
}
</style>
